import React, { useEffect, useState } from "react";
import axios from "axios";
import AddIcon from "../../Assests/Category/addIcon.svg";

import EditIcon from "../../Assests/Category/editIcon.svg";

import { fetchVendorsListData } from "../../Redux/features/VendorList/vListSlice";
import { useSelector, useDispatch } from "react-redux";
import { BASE_URL, STATUS_UPD_VENDORS } from "../../Constants/Config";

// import EditVendorsModal from './EditVendorsModal';
import Switch from "@mui/material/Switch";
import { Link, useNavigate } from "react-router-dom";
import { useAuthDetails } from "../../Common/cookiesHelper";
import AlertModal from "../../reuseableComponents/AlertModal";
import { priceFormate } from "../../hooks/priceFormate";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import PasswordShow from "../../Common/passwordShow";
import { CircularProgress, Grid } from "@mui/material";

//       table imports ----------------------------------------------------
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { SkeletonTable } from "../../reuseableComponents/SkeletonTable";
import { SortTableItemsHelperFun } from "../../helperFunctions/SortTableItemsHelperFun";
import sortIcon from "../../Assests/Category/SortingW.svg";
import NoDataFound from "../../reuseableComponents/NoDataFound";
import Pagination from "../../AllUserComponents/Users/UnverifeDetails/Pagination";
import { format } from "date-fns/esm";
import { fetchPermissions } from "../../Redux/features/Authentication/permissionsSlice";
import { PERMISSIONS } from "../../Constants/permission";
import { formatPhoneNumber } from "../../helperFunctions/formatPhoneNumber";
import AccessDeniedTooltip from "../../reuseableComponents/AccessDeniedTooltip";
// end table imports ----------------------------------------------------
const StyledTable = styled(Table)(({ theme }) => ({
  padding: 2, // Adjust padding as needed
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    // backgroundColor: "var(--qv-bg-f5f5f5, #F5F5F5)",
  },
  "& td, & th": {
    border: "none",
  },
}));

const VendorsDetail = ({ setVisible }) => {
  const dispatch = useDispatch();
  const { permissions, status, error } = useSelector(
    (state) => state.permissions
  );
  const hasAddVendorPermission =
    !permissions.length || permissions.includes(PERMISSIONS.MENU_ADD_VENDOR);
  const hasDisableVendorPermission =
    !permissions.length ||
    permissions.includes(PERMISSIONS.MENU_DISABLE_VENDOR);
  const hasEditVendorPermission =
    !permissions.length || permissions.includes(PERMISSIONS.MENU_EDIT_VENDOR);
  
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  const {
    handleCoockieExpire,
    getUnAutherisedTokenMessage,
    getNetworkError,
  } = PasswordShow();
  const navigate = useNavigate();
  const [allvendors, setallvendors] = useState([]);
  const AllVendorsDataState = useSelector((state) => state.vendors);
  const authUserData = useSelector((state) => state.authUser);
  // const dispatch = useDispatch();
  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    getVendorListData();
  }, [currentPage, rowsPerPage]);
  const getVendorListData = async () => {
    try {
      let data = {
        merchant_id: merchant_id,
        page_no: currentPage,
        limit: rowsPerPage,
      };
      await dispatch(fetchVendorsListData(data)).unwrap();
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  };
  
  useEffect(() => {
    const emp_id = window.localStorage.getItem("emp_id");
    if (emp_id !== null && emp_id !== undefined) {
      const requestData = { emp_id: emp_id };
      dispatch(fetchPermissions(requestData));
    }
  }, [dispatch]);

  useEffect(() => {
    if (AllVendorsDataState?.vendorListData?.["3"]) {
      setTotalCount(+AllVendorsDataState?.vendorListData?.["3"]);
    }
  }, [AllVendorsDataState, AllVendorsDataState?.vendorListData]);

  useEffect(() => {
    if (
      !AllVendorsDataState.loading &&
      AllVendorsDataState.vendorListData &&
      AllVendorsDataState.vendorListData.length >= 1
    ) {
      setallvendors(
        AllVendorsDataState.vendorListData[1].map((vendor) => {
          return { ...vendor, status: vendor.enabled === "1" ? 1 : 0 };
        })
      );
    }
  }, [
    AllVendorsDataState,
    AllVendorsDataState.loading,
    AllVendorsDataState.vendorListData,
  ]);
  // console.log("AllVendorsDataState", allvendors);
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [alertModalHeaderText, setAlertModalHeaderText] = useState("");
  const [statusLoadingId, setStatusLoadingId] = useState(null);
  const showModal = (headerText) => {
    setAlertModalHeaderText(headerText);
    setAlertModalOpen(true);
  };

  const handleUpdateStatus = async (event, label, vendorId) => {
    setStatusLoadingId(vendorId);
    try {
      const newStatus = event.target.checked ? 1 : 0;
      const updData = {
        // merchant_id: "MAL0100CA",
        merchant_id: merchant_id,
        status: event.target.checked ? 1 : 0,
        login_employee_id: LoginGetDashBoardRecordJson?.employee_id ? LoginGetDashBoardRecordJson?.employee_id : null,
        id: vendorId,
      };
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_URL + STATUS_UPD_VENDORS,
        { ...updData, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response);
      if (response.status === 200) {
        // alert("Vendor Status Updated Successfully.");
        ToastifyAlert("Updated Successfully.", "success");
        setallvendors(
          allvendors.map((vendor) => {
            if (vendor.vendor_id === vendorId) {
              return { ...vendor, status: newStatus };
            }
            return vendor; // add return statement here
          })
        );
      } else {
        // alert("something went wrong.");
        showModal("Something went wrong!");
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    } finally {
      setStatusLoadingId(null);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "2-digit" };
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-US", options);
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);
    return `${formattedDate} ${formattedTime}`;
  };
  const handleEditClick = (name, id) => {
    navigate(
      `/inventory/old-vendors/vendor-details/${encodeURIComponent(name)}?vendorId=${id}`
    );
  };
  const [sortOrder, setSortOrder] = useState("asc"); // "asc" for ascending, "desc" for descending
  const sortByItemName = (type, name) => {
    const itemWthoutDoller = allvendors.map((item) => {
      const dateString = item.recent_trans;
      const [date, doller] = dateString?.split("-") || "";
      return {
        ...item,
        recent_trans: date.trim(),
        vendor_name: item.vendor_name.trim(),
        doller: doller || "",
      };
    });

    const { sortedItems, newOrder } = SortTableItemsHelperFun(
      itemWthoutDoller,
      type,
      name,
      sortOrder
    );
    const itemWithSortedWitchDoller = sortedItems?.map((item) => {
      // const originalItem = allvendors.find(
      //   (vendor) => vendor.vendor_id === item.vendor_id
      // );
      // return { ...item, recent_trans: originalItem.recent_trans };
      return {
        ...item,
        recent_trans:
          item.recent_trans !== "" && item.doller !== ""
            ? `${item.recent_trans} - ${item.doller}`
            : "",
      };
    });
    setallvendors(itemWithSortedWitchDoller);
    setSortOrder(newOrder);
  };
  return (
    <>
      <Grid container sx={{}} className="box_shadow_div">
        <Grid item xs={12}>
          <Grid
            container
            directon="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Grid
                sx={{ px: { xs: 1, sm: 2.5 } }}
                className="q-category-bottom-header"
              >
                <span>Vendors</span>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                sx={{ px: { xs: 1, sm: 2.5 } }}
                className="q-category-bottom-header"
              >
                <AccessDeniedTooltip hasPermission={hasAddVendorPermission}>
                  <Link
                    to={`/inventory/old-vendors/add`}
                    className="add-vendor-for-android"
                    onClick={(e) => {
                      if (!hasAddVendorPermission) {
                        e.preventDefault();
                      }
                    }}
                  >
                    <p>
                      Add New Vendor <img src={AddIcon} alt="add-icon" />{" "}
                    </p>
                  </Link>
                </AccessDeniedTooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid container id="vendors-table">
            <div className="common-table-pagination">
              <Pagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={rowsPerPage}
                onPageChange={paginate}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setCurrentPage={setCurrentPage}
                showEntries={true}
                data={AllVendorsDataState.vendorListData}
              />
            </div>
            {AllVendorsDataState.loading ? (
              <>
                <SkeletonTable
                  columns={[
                    "Vendor Name",
                    "Contact",
                    "Email",
                    "Address",
                    "Status",
                    "",
                  ]}
                />
              </>
            ) : (
              <>
                <TableContainer>
                  <StyledTable>
                    <TableHead>
                      <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("str", "vendor_name")}
                        >
                          <p className="whitespace-nowrap">Vendor Name</p>
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell>
                      <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("num", "phone")}
                        >
                          <p className="whitespace-nowrap">Contact</p>
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell>
                      <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("str", "email")}
                        >
                          <p className="whitespace-nowrap">Email</p>
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell>
                      <StyledTableCell>
                        <button
                          className="flex items-center"
                          onClick={() => sortByItemName("str", "full_address")}
                        >
                          <p className="whitespace-nowrap">Address</p>
                          <img src={sortIcon} alt="" className="pl-1" />
                        </button>
                      </StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableHead>
                    <TableBody>
                      {allvendors && allvendors.length > 0
                        ? allvendors.map((singleVendor, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell>
                                <p
                                  className="text-[#0A64F9] cursor-pointer"
                                  onClick={() => {
                                    handleEditClick(
                                      singleVendor.vendor_name,
                                      singleVendor.vendor_id
                                    );
                                  }}
                                >
                                  {singleVendor.vendor_name}
                                </p>
                              </StyledTableCell>
                              <StyledTableCell>
                                <p>{formatPhoneNumber(singleVendor.phone)}</p>
                              </StyledTableCell>
                              <StyledTableCell>
                                <p>{singleVendor.email}</p>
                              </StyledTableCell>
                              <StyledTableCell>
                                {/* <p>{format(new Date(singleVendor.recent_trans.split("-")[0]),"HH/dd/yyyy")}</p> */}
                                <p>{singleVendor.full_address}</p>
                              </StyledTableCell>
                              <StyledTableCell>
                                <AccessDeniedTooltip
                                  hasPermission={hasDisableVendorPermission}
                                  loading={statusLoadingId === singleVendor.vendor_id}
                                >
                                  <span>
                                    <Switch
                                      onChange={(event) => {
                                        if (!hasDisableVendorPermission) return;
                                        handleUpdateStatus(
                                          event,
                                          label,
                                          singleVendor.vendor_id
                                        );
                                      }}
                                      {...label}
                                      checked={singleVendor.status}
                                      disabled={statusLoadingId === singleVendor.vendor_id}
                                    />
                                  </span>
                                </AccessDeniedTooltip>
                              </StyledTableCell>
                              <StyledTableCell>
                                {/* {(!permissions.length || (PERMISSIONS.MENU_EDIT_VENDOR) > -1) && <Link
                                  to={`/inventory/old-vendors/edit-vendor/${singleVendor.vendor_name}?vendorId=${singleVendor.vendor_id}`}
                                >
                                  <img
                                    className="edit_center"
                                    singleVender={singleVendor}
                                    // onClick={() => setVisible("EditVendors")}
                                    src={EditIcon}
                                    alt="Edit"
                                  />
                                </Link>} */}
                                <AccessDeniedTooltip hasPermission={hasEditVendorPermission}>
                                  <Link
                                    to={`/inventory/old-vendors/edit-vendor/${singleVendor.vendor_name}?vendorId=${singleVendor.vendor_id}`}
                                    onClick={(e) => {
                                      if (!hasEditVendorPermission) {
                                        e.preventDefault();
                                      }
                                    }}
                                  >
                                    <img
                                      className="edit_center"
                                      singleVender={singleVendor}
                                      // onClick={() => setVisible("EditVendors")}
                                      src={EditIcon}
                                      alt="Edit"
                                    />
                                  </Link>
                                </AccessDeniedTooltip>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))
                        : ""}
                    </TableBody>
                  </StyledTable>
                  {!allvendors.length && <NoDataFound />}
                </TableContainer>
              </>
            )}
            <div className="common-table-pagination">
              <Pagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={rowsPerPage}
                onPageChange={paginate}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setCurrentPage={setCurrentPage}
                showEntries={false}
                data={AllVendorsDataState.vendorListData}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
      {/* <div className="box">
        <div className="">
          <div className="q-category-bottom-header-sticky">
            <div className="q-category-bottom-header">
              <span>Vendors</span>
              <Link to={`/inventory/old-vendors-add`}>
           
              </Link>
            </div>
            <div className="q-category-bottom-categories-header">
              <p className="table20">Vendor Name</p>
              <p className="table15">Payment Count</p>
              <p className="table15">Amount</p>
              <p className="table30">Recent Transaction</p>
              <p className="table20">Status</p>
            </div>
          </div>
          <div className="q-category-bottom-categories-listing">
            {allvendors &&
              allvendors.length >= 1 &&
              allvendors.map((singleVender, index) => {
                return (
                  <div

                  // to={`/vendors/vendor-details/${singleVender.vendor_name}?vendorId=${singleVender.vendor_id}`}
                  >
                    <div
                      className="q-category-bottom-categories-single-category"
                      key={index}
                    >
                      <p className="table20">{singleVender.vendor_name}</p>
                      <p className="table15">
                        {priceFormate(singleVender.pay_count)}
                      </p>
                      <p className="table15">
                        $
                        {typeof singleVender.amount === "number"
                          ? priceFormate(singleVender.amount.toFixed(2))
                          : priceFormate(
                              parseFloat(singleVender.amount).toFixed(2)
                            )}
                      </p>

                      <p className="table30">
                        <Link
                          to={`/inventory/old-vendors/vendor-details/${encodeURIComponent(
                            singleVender.vendor_name
                          )}?vendorId=${singleVender.vendor_id}`}
                        >
                          {singleVender.recent_trans}
                        </Link>
                      </p>
                      <p className="table20">
                        <div className="qvrow">
                          <div className="col-qv-4">
                
                            <Switch
                              onChange={(event) =>
                                handleUpdateStatus(
                                  event,
                                  label,
                                  singleVender.vendor_id
                                )
                              }
                              {...label}
                              defaultChecked={singleVender.enabled === "1"}
                              disabled={statusLoadingId === singleVender.vendor_id}
                            />
                            {statusLoadingId === singleVender.vendor_id ? (
                              <CircularProgress size={16} sx={{ ml: 1 }} />
                            ) : null}
                          </div>
                          <div className="col-qv-4">
                           
                          </div>

                          <div className="col-qv-4">
                            <Link
                              to={`/inventory/old-vendors/edit-vendor/${singleVender.vendor_name}?vendorId=${singleVender.vendor_id}`}
                            >
                              <img
                                className="edit_center"
                                singleVender={singleVender}
                                // onClick={() => setVisible("EditVendors")}
                                src={EditIcon}
                                alt="Edit"
                              />
                            </Link>
                          </div>

                          
                        </div>
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div> */}
      <AlertModal
        headerText={alertModalHeaderText}
        open={alertModalOpen}
        onClose={() => {
          setAlertModalOpen(false);
        }}
      />
    </>
  );
};

export default VendorsDetail;
